/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var inputNumberDefaultProps = {
  allowInputOverLimit: true,
  autoWidth: false,
  decimalPlaces: void 0,
  largeNumber: false,
  max: Infinity,
  min: -Infinity,
  placeholder: void 0,
  readonly: false,
  size: "medium",
  status: "default",
  step: 1,
  theme: "row"
};

export { inputNumberDefaultProps };
//# sourceMappingURL=defaultProps.js.map
